import React from "react";
import {Form} from "react-bootstrap"

const HeaderCounters = (props) => {

    const counters = props.counters;
    const textList = props.textList;
    const showDetail = props.showDetail;
    const detail = props.detail;

    return (
        <>
            { counters && 
                <>
                    <Form.Label>
                        {
                            Object.entries(counters).map((counter, index) => {
                                return textList[index] + " " + counter[1] + ((index % 2 !== 0) ? "" : " | ")
                            })
                        }
                    </Form.Label>
                    <>
                    { showDetail &&
                        <Form.Label>
                            {detail !== null ? detail : ""}
                        </Form.Label>
                    }
                    </>
                </>
            }
        </>
    );
};

export default HeaderCounters;